import {SwiperListBaseModel} from "../swiper-list-base.model";
import {JackpotBetWidgetComponent} from "../../../../../components/jackpot-bet-widget/jackpot-bet-widget.component";
import {SwiperBox} from "../../../../../components/orbit-swiper/boxes/swiper/swiper.box";
import classNames from "classnames";
import {CyClass} from "../../../../../../common/cy-classes";
import React from "react";
import {OrbitSwiperComponent} from "../../../../../components/orbit-swiper/orbit-swiper.component";
import {
    JackpotBetWidgetMobileWrapperBox
} from "../../../../../components/jackpot-bet-widget/boxes/jackpot-bet-widget-mobile-wrapper.box";
import {
    JackpotBetWidgetPCWrapperBox
} from "../../../../../components/jackpot-bet-widget/boxes/jackpot-bet-widget-pc-wrapper.box";

export class JackpotBetListModel extends SwiperListBaseModel {

    protected _getGameTypes(): number[] {
        return this.listConfiguration.gamesId || [];
    }

    renderSpecialWidgets(): React.ReactElement | null {
        return (
          <JackpotBetWidgetComponent
              listName={this.listConfiguration.title}
              arenaName={this.arenaName}
              widgetConfig={this.listConfiguration.jackpotBetsWidget}
              WrapperBox={JackpotBetWidgetPCWrapperBox}
          />
        );
    }

    protected _renderList(listPosition: number): React.ReactElement | null {
        //On resize, the swiper-window component triggers this function again, so we don't need this if in an observer
        if (this.services.mediaQuery.sAndBelow) {
            return (
                <SwiperBox className={classNames(CyClass('cy-orbit-swiper'))}>
                    {this.renderListHeader()}
                    <JackpotBetWidgetComponent
                        listName={this.listConfiguration.title}
                        arenaName={this.arenaName}
                        useSquareIcons={this.listConfiguration.useSquareIcons}
                        widgetConfig={this.listConfiguration.jackpotBetsWidget}
                        WrapperBox={JackpotBetWidgetMobileWrapperBox}
                        gameTypes={this.gameTypes}/>
                    {this.renderListFooter()}
                </SwiperBox>
            );
        } else {
            return (
                <OrbitSwiperComponent
                    className={"cy-jackpot-bet-list"}
                    viewModel={this}
                    key={this.listKey}
                    listPosition={listPosition}
                    showNumberBadge={this.listConfiguration.showNumberBadge}
                />
            );
        }
    }
}